import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import beautyImage from "../../static/media/Home/intro.webp";

const PRIMARY = "#06BBC7";

const BeautyIntro = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        bgcolor: "#ffffff",
        py: { xs: 6, md: 9 },
        overflow: "hidden",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 4.5, md: 7 },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "52%" },
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            sx={{
              width: { xs: "92%", sm: "78%", md: "80%" },
              maxWidth: { xs: 420, md: 620 },
              position: "relative",
              overflow: "hidden",
              borderRadius: { xs: "22px", md: "34px" },
              "&::before": {
                content: '""',
                position: "absolute",
                inset: 0,
                zIndex: 2,
                pointerEvents: "none",
                background: `
                  linear-gradient(to right, #fff 0%, rgba(255,255,255,0) 14%, rgba(255,255,255,0) 86%, #fff 100%),
                  linear-gradient(to bottom, #fff 0%, rgba(255,255,255,0) 14%, rgba(255,255,255,0) 86%, #fff 100%)
                `,
              },
            }}
          >
            <Box
              component="img"
              src={beautyImage}
              alt="Tratamientos estéticos y cuidado corporal profesional"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.75, ease: "easeOut" }}
          sx={{
            width: { xs: "100%", md: "48%" },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Box
            sx={{
              width: { xs: 190, sm: 250 },
              mb: 2,
              mx: { xs: "auto", md: 0 },
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              color: PRIMARY,
            }}
          >
            <Box sx={{ flex: 1, height: 2, bgcolor: PRIMARY, borderRadius: 10 }} />
            <Box sx={{ width: 7, height: 7, bgcolor: PRIMARY, borderRadius: "50%" }} />
            <Typography
              component="span"
              sx={{
                fontSize: { xs: 26, sm: 31 },
                lineHeight: 1,
                color: PRIMARY,
                fontWeight: 300,
              }}
            >
              ✽
            </Typography>
            <Box sx={{ width: 7, height: 7, bgcolor: PRIMARY, borderRadius: "50%" }} />
            <Box sx={{ flex: 1, height: 2, bgcolor: PRIMARY, borderRadius: 10 }} />
          </Box>

          <Typography
            component="p"
            sx={{
              fontSize: { xs: "0.82rem", md: "0.9rem" },
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: PRIMARY,
              mb: 1.4,
            }}
          >
            Bienvenidos a Lily´s Sunflowers
          </Typography>

          <Typography
            component="h2"
            sx={{
              fontFamily: "'Playfair Display', serif",
              fontSize: { xs: "2.1rem", sm: "2.75rem", md: "3.45rem" },
              lineHeight: 1.04,
              fontWeight: 500,
              color: "#1d2530",
              letterSpacing: "-0.04em",
              mb: 2.4,
            }}
          >
            Belleza estética con cuidado consciente
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "0.98rem", md: "1.08rem" },
              lineHeight: 1.8,
              color: "#374151",
              maxWidth: 560,
              mx: { xs: "auto", md: 0 },
              mb: 2.2,
              fontWeight: 400,
            }}
          >
            En Lily´s Sunflowers realizamos tratamientos faciales, corporales,
            mesoterapia, peluquería y depilación profesional con protocolos
            personalizados para cuidar tu piel, tu cuerpo y tu imagen.
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "0.98rem", md: "1.08rem" },
              lineHeight: 1.8,
              color: "#374151",
              maxWidth: 560,
              mx: { xs: "auto", md: 0 },
              mb: 2.8,
              fontWeight: 400,
            }}
          >
            Combinamos técnica profesional, productos de calidad y atención
            cercana para ofrecerte resultados visibles en un espacio seguro,
            cálido y pensado para tu bienestar.
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "1.03rem", md: "1.12rem" },
              fontWeight: 700,
              color: "#1f2937",
              mb: 1.6,
            }}
          >
            Tratamientos que ofrecemos
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: { xs: 1.1, md: 1.3 },
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            {[
              "Faciales",
              "Corporales",
              "Mesoterapia",
              "Peluquería",
              "Depilación profesional",
            ].map((item) => (
              <Box
                key={item}
                sx={{
                  px: 2,
                  py: 0.9,
                  borderRadius: "999px",
                  bgcolor: "rgba(6, 187, 199, 0.08)",
                  color: "#1f2937",
                  fontSize: { xs: "0.9rem", md: "0.95rem" },
                  fontWeight: 700,
                  border: "1px solid rgba(6, 187, 199, 0.16)",
                }}
              >
                {item}
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BeautyIntro;